import { IsNumber, IsString } from 'class-validator';

export class PosValidateManagerPinRequestDto {

  public managerAccessPin?: string;


  public posAccessPin?: string;

  @IsNumber()
  public costCentreId: number;

  constructor(managerAccessPin: string, constCenterId: number) {
    this.managerAccessPin = managerAccessPin;
    this.costCentreId = constCenterId;
  }
}
